<template>
  <div class="page">
    <nav-bar />
    <div class="page-wrapper">
      <div class="stats">
        <div class="stats__main">
          <h1 class="editor--title">Статистика посещений</h1>
          <div class="stats__tabs">
            <button
              class="stats__tab"
              v-for="(item, index) in dateVariants"
              :key="index"
              :class="{ 'stats__tab--active': item.isActive }"
              @click="setEnable(index)"
            >
              {{ item.name }}
            </button>
          </div>

          <div class="stats__row">
            <div class="stats__counter stats__counter--green">
              <p class="stats__counter__title">
                Уникальные посетители
              </p>
              <p class="stats__counter__number">
                {{ totalVisitData[1] }}
              </p>
              <div class="tip-wrapper">
                <CTooltip
                  :action="show_tooltip.tooltip_uniq"
                  :position="tooltip_position"
                  >{{ tooltip_uniq }}</CTooltip
                >
                <div
                  class="tip"
                  @click="
                    show_tooltip.tooltip_uniq = !show_tooltip.tooltip_uniq
                  "
                >
                  <img
                    src="../assets/img/question.svg"
                    width="28"
                    height="28"
                  />
                </div>
              </div>
            </div>
            <div class="stats__counter stats__counter--yellow">
              <p class="stats__counter__title">
                Количество посещений
              </p>
              <p class="stats__counter__number">
                {{ totalVisitData[0] }}
              </p>
              <div class="tip-wrapper">
                <CTooltip
                  :action="show_tooltip.tooltip_all"
                  :position="tooltip_position"
                  >{{ tooltip_all }}</CTooltip
                >
                <div
                  class="tip"
                  @click="show_tooltip.tooltip_all = !show_tooltip.tooltip_all"
                >
                  <img
                    src="../assets/img/question.svg"
                    width="28"
                    height="28"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="stats__row">
            <div class="age">
              <h2>Возраст</h2>
              <div class="graph_source">
                <div class="bar-chart_size">
                  <bar-chart
                    v-if="loaded"
                    :chart-data="ageGenderData"
                    :options="ageGenderChartOptions"
                  />
                </div>
                <div class="tip-wrapper">
                  <CTooltip
                    :action="show_tooltip.tooltip_age"
                    :position="tooltip_position"
                    >{{ tooltip_age }}</CTooltip
                  >
                  <div
                    class="tip"
                    @click="
                      show_tooltip.tooltip_age = !show_tooltip.tooltip_age
                    "
                  >
                    <img
                      src="../assets/img/question.svg"
                      width="28"
                      height="28"
                    />
                  </div>
                </div>
                <ul>
                  <li>
                    Мужчины
                  </li>
                  <li>
                    Женщины
                  </li>
                </ul>
              </div>
            </div>
            <div class="column2 row2 block4">
              <h2>Посетители</h2>
              <div class="graph_source">
                <div class="line-chart_size">
                  <VerticalBarChart
                    :width="624"
                    :height="241"
                    v-if="loaded"
                    :chart-data="barVisitsData"
                    :options="visitChartOptions"
                  />
                </div>
                <div class="graph_dates">
                  <p>{{ prev_date }}</p>
                  <p>{{ today }}</p>
                </div>
                <ul>
                  <li>
                    Уникальные
                  </li>
                  <li>
                    Всего
                  </li>
                </ul>
              </div>
              <div class="tip-wrapper">
                <CTooltip
                  :action="show_tooltip.tooltip_graph"
                  :position="tooltip_position"
                  >{{ tooltip_graph }}</CTooltip
                >
                <div
                  class="tip"
                  @click="
                    show_tooltip.tooltip_graph = !show_tooltip.tooltip_graph
                  "
                >
                  <img
                    src="../assets/img/question.svg"
                    width="28"
                    height="28"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="stats__buttons">
          <button
            class="pBtn pBtn--noborder"
            @click="
              () => {
                $router.push('/');
                this.GAEvent('statistics_back');
              }
            "
          >
            <svg-icon type="back" /> Назад
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AvatarCropper from "@/components/AvatarCropper";
import { mapState, mapActions } from "vuex";
import BackLink from "@/components/BackLink";
import BarChart from "@/components/charts/BarChart";
import VerticalBarChart from "../components/charts/VerticalBarChart";
import Doughnut from "@/components/charts/Doughnut";
import VueDropdown from "@/components/vue-dropdown";
import CTooltip from "../components/forms/CTooltip";
import moment from "moment";

require("moment/locale/ru");
moment.locale("ru");

export default {
  components: {
    BackLink,
    AvatarCropper,
    BarChart,
    Doughnut,
    VueDropdown,
    CTooltip,
    VerticalBarChart
  },
  data() {
    return {
      config: {
        options: [
          {
            value: "Год"
          },
          {
            value: "Квартал"
          },
          {
            value: "Месяц"
          },
          {
            value: "Неделя"
          },
          {
            value: "Вчера"
          },
          {
            value: "Сегодня"
          }
        ],
        placeholder: "Месяц",
        backgroundColor: "#ffffff",
        textColor: "#0A467E",
        borderRadius: "2px",
        border: "1px solid #E0E0E0",
        width: 200
      },
      dateVariants: [
        /*{
          name: "Сегодня",
          isActive: false,
          dDays: -1
        },*/

        {
          name: "Вчера",
          isActive: false,
          dDays: -2
        },

        {
          name: "Неделя",
          isActive: false,
          dDays: -7
        },

        {
          name: "Месяц",
          isActive: false,
          dDays: -30
        },
        {
          name: "Квартал",
          isActive: false,
          dDays: -90
        },
        {
          name: "Год",
          isActive: true,
          dDays: -365
        }
      ],
      loaded: false,
      prev_date: 1,
      today: 1,
      visitData: null,
      barVisitsData: null,
      ageGenderData: null,
      visitChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        title: {
          display: false
        },
        showScale: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              display: true
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                borderDash: [2, 5]
              },
              stacked: false,
              ticks: {
                min: 0,
                maxTicksLimit: 5
              }
            }
          ]
        },
        scaleSteps: null,
        scaleShowLabels: false,
        showTooltips: true
      },
      ageGenderChartOptions: {
        showScale: false,
        scaleFontStyle: "normal",
        scaleFontColor: "#000",
        scaleFontSize: 16,
        scaleShowVerticalLines: false,
        scaleLineColor: "white",
        borderColor: "white",
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              display: false
            }
          ],
          yAxes: [
            {
              beginAtZero: true,
              borderWidth: 0,
              color: "white",
              gridLines: {
                color: "white",
                zeroLineWidth: 0,
                display: false
              },
              ticks: {
                display: true
              }
            }
          ]
        },
        legend: {
          display: false
        },
        responsive: true,
        height: 100
      },
      totalVisitData: [0, 0],
      tooltip_position: "right",
      tooltip_uniq:
        "Количество посетителей, зашедших на вашу страницу за определенное время.",
      tooltip_all:
        "Количество заходов на вашу Личную страницу, которое совершили посетители.",
      tooltip_age: "Возраст и пол посетителей вашей страницы.",
      tooltip_graph:
        "Количество посещений вашей страницы за промежутки времени.",
      show_tooltip: {
        tooltip_uniq: false,
        tooltip_all: false,
        tooltip_age: false,
        tooltip_graph: false
      }
    };
  },
  computed: {
    ...mapState(["user", "page"]),
    avatar() {
      if (this.user && this.user.avatar) {
        return this.user.avatar;
      }
      return require("@/assets/img/avatar-dark.svg");
    }
  },
  mounted() {
    this.getData();
  },

  methods: {
    setNewSelectedOption(selectedOption) {
      this.config.placeholder = selectedOption.value;
      this.dateVariants.forEach(d => {
        d.isActive = selectedOption.value === d.name;
      });
      this.getData();
    },
    setEnable(j) {
      this.dateVariants.forEach(function(item, i) {
        item.isActive = i === j;
      });
      this.GAEvent(
        "statistics_period",
        "click_text",
        this.dateVariants.find(i => i.isActive).name
      );
      this.getData();
    },

    handleInput(data, key) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.syncUser({ [key]: data });
      }, 500);
    },
    ...mapActions(["syncUser"]),
    handleUploaded(response) {
      this.syncUser({ avatar: response.result.file });
    },
    getData() {
      const url = `${process.env.VUE_APP_API_ROOT}/api/statistics/filter`;
      const filterData = {};
      const today = new Date();
      const dateFilter = this.dateVariants.find(i => i.isActive);
      const dateGT = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + dateFilter.dDays
      );
      let days = dateFilter.dDays;
      filterData.date__gt = moment(dateGT).format("YYYY-MM-DD");
      filterData.date__lte = moment(today).format("YYYY-MM-DD");
      filterData.abo_number = this.user.abo_number;
      fetch(`${url}?${new URLSearchParams(filterData).toString()}`, {
        method: "GET",
        credentials: "include"
      })
        .then(r => r.json())
        .then(response => {
          this.prev_date = filterData.date__gt;
          this.today = filterData.date__lte;
          if (!response.visits.list.length) {
            this.totalVisitData = [0, 0];
          } else {
            this.totalVisitData = response.visits.total;
          }
          const barVisits = [];
          const barUsers = [];
          const barLabels = [];
          let counterDate = moment(this.prev_date);
          let endDate = moment(this.today);
          switch (dateFilter.dDays) {
            case -365:
            case -90:
              //разбиваем по месяцам
              while (counterDate <= endDate) {
                let dateRegexp = new RegExp(
                  `^${counterDate.year()}\-${
                    counterDate.month() + 1 < 10
                      ? "0" + (counterDate.month() + 1)
                      : counterDate.month() + 1
                  }`
                );
                let dateLabel = counterDate.format("MMM YYYY");
                barLabels.push(dateLabel);
                let affectedVisits = response.visits.list.filter(v =>
                  dateRegexp.test(v.date)
                );
                if (affectedVisits.length) {
                  let visitsCounter = 0,
                    usersCounter = 0;
                  affectedVisits.forEach(i => {
                    visitsCounter += i.visit_data[0];
                    usersCounter += i.visit_data[1];
                  });
                  barVisits.push(visitsCounter);
                  barUsers.push(usersCounter);
                } else {
                  barVisits.push(0);
                  barUsers.push(0);
                }
                counterDate = counterDate.add(1, "M");
              }
              let lastDateRegexp = new RegExp(
                `^${counterDate.year()}\-${
                  counterDate.month() + 1 < 10
                    ? "0" + (counterDate.month() + 1)
                    : counterDate.month() + 1
                }`
              );
              let lastDateLabel = counterDate.format("MMM YYYY");
              barLabels.push(lastDateLabel);
              let affectedVisits = response.visits.list.filter(v =>
                lastDateRegexp.test(v.date)
              );
              if (affectedVisits.length) {
                let visitsCounter = 0,
                  usersCounter = 0;
                affectedVisits.forEach(i => {
                  visitsCounter += i.visit_data[0];
                  usersCounter += i.visit_data[1];
                });
                barVisits.push(visitsCounter);
                barUsers.push(usersCounter);
              } else {
                barVisits.push(0);
                barUsers.push(0);
              }
              break;
            case -30:
            case -7:
            case -2:
              // разбиваем по дням:
              while (counterDate <= endDate) {
                let dateLabel = counterDate.format("DD MMM");
                barLabels.push(dateLabel);
                let affectedVisit = response.visits.list.find(
                  v => v.date === counterDate.format("YYYY-MM-DD")
                );
                if (affectedVisit) {
                  barVisits.push(affectedVisit.visit_data[0]);
                  barUsers.push(affectedVisit.visit_data[1]);
                } else {
                  barVisits.push(0);
                  barUsers.push(0);
                }
                counterDate = counterDate.add(1, "d");
              }
              break;
          }
          this.barVisitsData = {
            labels: barLabels,
            datasets: [
              {
                label: "Всего",
                borderColor: "#FFEE58",
                borderWidth: 3,
                backgroundColor: "#FFEE58",
                pointRadius: 0,
                data: barVisits
              },
              {
                label: "Уникальные",
                borderColor: "#26CC72",
                borderWidth: 3,
                backgroundColor: "#26CC72",
                pointRadius: 0,
                data: barUsers
              }
            ]
          };
          const males = response.age_gender.list.filter(
            a => a.gender === "male"
          );
          const females = response.age_gender.list.filter(
            a => a.gender === "female"
          );
          let ageLabels = [];
          const malesData = {};
          const femalesData = {};
          males.forEach(m => {
            if (!ageLabels.includes(m.age.replace("Age ", ""))) {
              ageLabels.push(m.age.replace("Age ", ""));
            }
            if (!malesData[m.age]) {
              malesData[m.age] = m.visit_data[1];
            } else {
              malesData[m.age] += m.visit_data[1];
            }
          });
          females.forEach(m => {
            if (!ageLabels.includes(m.age.replace("Age ", ""))) {
              ageLabels.push(m.age.replace("Age ", ""));
            }
            if (!femalesData[m.age]) {
              femalesData[m.age] = m.visit_data[1];
            } else {
              femalesData[m.age] += m.visit_data[1];
            }
          });
          ageLabels = ageLabels.sort();
          const malesDataset = [];
          const femalesDataset = [];
          ageLabels.forEach(l => {
            if (malesData[`Age ${l}`]) {
              malesDataset.push(malesData[`Age ${l}`]);
            } else {
              malesDataset.push(0);
            }
            if (femalesData[`Age ${l}`]) {
              femalesDataset.push(femalesData[`Age ${l}`]);
            } else {
              femalesDataset.push(0);
            }
          });
          this.ageGenderData = {
            labels: ageLabels,
            datasets: [
              {
                label: "Мужчины",
                borderColor: "#767BFF",
                backgroundColor: "#767BFF",
                pointBackgroundColor: "white",
                borderWidth: 0,
                pointBorderColor: "#767BFF",
                showScale: false,
                data: malesDataset
              },
              {
                label: "Женщины",
                borderColor: "#FF5858",
                backgroundColor: "#FF5858",
                pointBackgroundColor: "white",
                borderWidth: 0,
                pointBorderColor: "#FF5858",
                data: femalesDataset
              }
            ]
          };
          this.loaded = true;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/vars";
//page layout
.page {
  background: #3479cc;
  @media #{$tablet} {
    padding-bottom: 0;
  }

  &-wrapper {
    max-width: 100%;
    display: flex;
    justify-content: center;
    @media #{$tablet} {
      margin: 0;
      padding: 0;
    }
  }
}

.tip-wrapper {
  position: absolute;
  right: 22px;
  bottom: 22px;
  color: #fff !important;
}

.tooltip {
  color: #fff !important;
}

.tip {
  width: 28px;
  height: 28px;

  background-color: #fff;
  border-radius: 50%;

  cursor: pointer;
}

.stats {
  width: 100%;
  max-width: 1200px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  /deep/ .editor--title {
    font-size: 34px;
    line-height: 140%;
  }
  * {
    font-family: Inter, sans-serif;
  }
  @media #{$tablet} {
    min-height: calc(100vh - 75px);
    border-radius: 0;
    justify-content: space-between;
  }
  &__main {
    padding: 40px 70px;
    @media #{$tablet} {
      padding: 30px;
    }
    @media #{$mobile} {
      padding: 30px 15px;
    }
  }

  .editor--title {
    margin-bottom: 45px;
  }

  &__tabs {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }

  &__tab {
    border: none;
    outline: none;
    background: transparent;
    font-size: 16px;
    color: #303333;
    cursor: pointer;
    @media #{$mobile} {
      padding: 0;
      margin-right: 31px;
      line-height: 2;
    }
    &--active {
      color: #3a5eec;
    }
  }

  &__row {
    display: flex;
    margin-bottom: 30px;
    @media #{$mobile} {
      flex-wrap: wrap;
      margin-bottom: 0;
    }
  }

  &__counter {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 46px 12px 22px;
    width: 360px;
    height: 160px;
    border-radius: 12px;
    @media #{$tablet} {
      width: 340px;
      padding: 30px 22px;
    }
    @media #{$mobile} {
      width: 100%;
      margin-right: 0 !important;
      margin-bottom: 20px;
    }
    &:not(:last-child) {
      margin-right: 30px;
      @media #{$tablet} {
        margin-right: 20px;
      }
    }
    &--green {
      background: #26cc73;
      * {
        color: #ffffff;
      }
    }
    &--yellow {
      background: #ffee58;
      * {
        color: #303333;
      }
    }
    &__title {
      font-size: 24px;
      font-weight: 600;
      margin: 0;
      padding: 0;
    }

    &__number {
      font-size: 48px;
      font-weight: bold;
      margin: 0;
      padding: 0;
    }
  }
  &__buttons {
    background: #ffffff;
    padding: 30px 70px;
    display: flex;
    justify-content: space-between;
    @media #{$tablet} {
      flex-direction: column-reverse;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 0 15px;
    }
    @media #{$mobile} {
      align-items: center;
    }
  }
}

.wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media screen and (max-width: 700px) {
    justify-content: center;
  }
}

//general
h1 {
  @media screen and (max-width: 700px) {
    font-size: 35px;
    line-height: 41px;
  }
  @media screen and (max-width: 450px) {
    font-size: 24px;
    line-height: 28px;
  }
}

h2 {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  display: flex;
  align-items: center;
  color: rgba(33, 33, 33, 0.87);
  margin: 0 0 15px 0;
}

a {
  color: #0a467e;
}

.dropdown {
  display: none;
  position: absolute;
  @media screen and (max-width: 700px) {
    display: flex;
  }
}

//content layout
.col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 20px;
}

.row {
  display: flex;
}

.column {
  background-color: white;
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  flex-direction: column;
  padding: 30px 25px;
  @media screen and (max-width: 860px) {
    flex-direction: column;
  }
}

.column2 {
  display: flex;
  flex-direction: column;
  border: 1px solid #cccccc;
  border-radius: 12px;
  width: 360px;
  padding: 30px 22px;
  margin-right: 30px;
  h2 {
    color: #303333;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 25px;
  }
}

.row1 {
  min-width: 279px;
  margin-right: 55px;
  @media screen and (max-width: 860px) {
    margin-bottom: 55px;
  }
  @media screen and (max-width: 700px) {
    margin-right: 0;
  }
}

.row2 {
  //width: calc(70% - 40px);
  width: 673px;
  @media screen and (max-width: 1080px) {
    width: calc(70% - 110px);
  }
  @media screen and (max-width: 860px) {
    max-width: 612px;
    width: 100%;
  }
}

//visits
.visits {
  display: flex;
  width: 100%;
  min-height: 139px;
  margin-bottom: 55px;
  @media screen and (max-width: 860px) {
    flex-direction: column;
    width: 279px;
    margin-bottom: 0;
  }
  @media screen and (max-width: 700px) {
    width: 100%;
    justify-content: center;
    margin-bottom: 55px;
    margin-top: 90px;
  }
}

.description_visits {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.15px;
  color: #000000;
  margin: 0;
}

.number_visits {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  letter-spacing: 0.15px;
  color: #0a467e;
  margin: 0;
}

//graph source
.block3 {
  margin-bottom: 55px;
  @media screen and (max-width: 860px) {
  }
  @media screen and (max-width: 700px) {
    margin-right: 0 !important;
    width: 100%;
  }
}

.graph_source {
}

.graph_source ul {
  padding: 0;
  margin: 0;
  display: flex;
}

.graph_source li {
  list-style-type: none;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 31px;
  letter-spacing: 0.15px;
  margin-right: 25px;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  align-items: center;
}

.graph_source li:before {
  content: "";
  display: inline-block;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  margin-right: 8px;
  background-repeat: no-repeat;
}

.graph_source li:nth-child(1):before {
  background-color: #26cc72;
}

.graph_source li:nth-child(2):before {
  background-color: #ffee58;
}

.graph_source li:nth-child(3):before {
  background-color: #ff5c5c;
}

.graph_source li:nth-child(4):before {
  background-color: #3183f1;
}

.doughnut_size {
  width: 207px;
  margin-bottom: 20px;
  @media screen and (max-width: 700px) {
    margin-left: 65px;
  }
  @media screen and (max-width: 450px) {
    margin-left: 0;
  }
}

//graph visits
.block4 {
  position: relative;
  @media #{$tablet} {
    width: 340px;
  }
  @media #{$mobile} {
    width: 100%;
    flex: 0 0 100%;
  }
}

.graph_dates {
  display: flex;
  flex-direction: row;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 28px;
  color: #bdbdbd;
  justify-content: space-between;
  margin-bottom: 40px;
  @media screen and (max-width: 1080px) {
    //margin-top: -70px;
  }
  @media screen and (max-width: 960px) {
    //margin-top: -90px;
  }
  @media screen and (max-width: 860px) {
    //margin-top: 0;
  }
}

.graph_dates p {
  margin: 0;
}

.line-chart_size {
  max-width: 624px;
  height: 241px;
}

//age
.block5 {
  height: 435px;
  @media #{$tablet} {
    width: 612px;
  }
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.age {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #cccccc;
  border-radius: 12px;
  width: 360px;
  flex: 0 0 360px;
  padding: 30px 22px;
  margin-right: 30px;
  h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 25px;
  }
  @media #{$tablet} {
    width: 340px;
    margin-top: 0;
    margin-right: 22px;
    flex: 0 0 340px;
  }
  @media #{$mobile} {
    margin-right: 0;
    margin-bottom: 20px;
    width: 100%;
    flex: 0 0 100%;
  }
  @media screen and (max-width: 700px) {
    justify-content: center;
  }
}

.age ul {
  padding: 0;
  margin: 0;
  display: flex;
}

.age li {
  list-style-type: none;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 31px;
  letter-spacing: 0.15px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  &:not(:last-child) {
    margin-right: 25px;
  }
}

.age li:nth-child(1):before {
  background-color: #767bff;
}

.age li:nth-child(2):before {
  background-color: #ff5858;
}

.age li:nth-child(1) {
  @media screen and (max-width: 860px) {
    margin-right: 30px;
  }
}

.bar-chart_size {
  width: 228px;
  /*height: 170px;*/
  margin-bottom: 40px;
}

//links
.block6 {
  @media screen and (max-width: 860px) {
    width: 612px;
    height: 360px;
  }
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.link_source ul {
  padding-left: 0;
  overflow: hidden;
  flex-direction: column;
}

.link_source li {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 31px;
  letter-spacing: 0.15px;
  list-style-type: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
